"use strict";
exports.__esModule = true;
exports.createInterfaceForSchema = void 0;
var _1 = require(".");
function createInterfaceForSchema(schema, interfaceName) {
    // console.log(schema, "sche");
    var text = "type ".concat(interfaceName, " = ").concat(getTypeForField(schema), ";\n");
    return text;
}
exports.createInterfaceForSchema = createInterfaceForSchema;
function getTypeForField(field, depth) {
    if (depth === void 0) { depth = 0; }
    if (!field)
        return "";
    if (field.type === "object") {
        var typeList = Object.keys(field.fields)
            .map(function (key) {
            var _a, _b, _c, _d;
            var isRequired = (_b = (_a = field.fields[key]) === null || _a === void 0 ? void 0 : _a.exclusiveTests) === null || _b === void 0 ? void 0 : _b.required;
            if ((_d = (_c = field.fields[key]) === null || _c === void 0 ? void 0 : _c.spec) === null || _d === void 0 ? void 0 : _d.nullable)
                isRequired = false;
            return "".concat((0, _1.depthSpaces)(depth + 1)).concat(key).concat(isRequired ? "" : "?", ": ").concat(getTypeForField(field.fields[key], depth + 1), ";");
        })
            .join("\n");
        return "{\n".concat(typeList, "\n").concat((0, _1.depthSpaces)(depth), "}");
    }
    else if (field.type === "array") {
        return "".concat(getTypeForField(field.innerType, depth), "[]");
    }
    else if (field.type === "date") {
        return "Date";
    }
    else {
        return field.type;
    }
}
//# sourceMappingURL=yupGenerator.js.map